import { Card } from 'antd';
import type { PublicationDetailOut } from '@/api/generated/schemas';
import { PublicationActivityFeed } from '@/components/user_catalog/publications/PublicationActivityFeed';

interface PublicationActivitiesTabProps {
  record: PublicationDetailOut;
}

export const PublicationActivitiesTab = ({
  record,
}: PublicationActivitiesTabProps) => (
  <Card>
    <PublicationActivityFeed publicationId={record.id} />
  </Card>
);
